import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { tagActions } from 'src/app/features/tag/tag.actions'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { filter, take } from 'rxjs/operators'
import { AccessRights } from 'src/app/features/role/user-role/user-role'

@Component({
  selector: 'configuration-option-secondary-tag-filter',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionSecondaryTagFilterCardComponent
  implements OnInit
{
  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues$: Observable<any>
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  public form: UntypedFormGroup
  public isLoading$: Observable<boolean>
  public selectedLanguage$: Observable<string>
  public maxNumberOfExampleTags: number = 3
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {}

  get configSetsFormArray() {
    return this.form?.controls?.configSets as UntypedFormArray
  }

  ngOnInit() {
    this.form = this.fb.group({
      configSets: this.fb.array([])
    })

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )

    this.store.dispatch(tagActions.fetchMany({}))

    this.formValues$
      .pipe(
        filter(
          (formValues) =>
            formValues?.secondary_tag_filter_config !== undefined &&
            formValues?.secondary_tag_filter_config !== null
        ),
        take(1)
      )
      .subscribe((formValues) => {
        const configSets = JSON.parse(
          formValues?.secondary_tag_filter_config || '[]'
        )

        configSets.map(() =>
          this.configSetsFormArray?.length < configSets?.length
            ? this.addConfigSetRow()
            : null
        )

        this.form?.patchValue({
          configSets
        })
      })
  }

  public getConfigSetRow() {
    return this.fb.group({
      ordinal: [null, [Validators.required]],
      tagLevel: [null, [Validators.required]],
      activeState: [false],
      title_en: [null, [Validators.required]],
      title_nl: [
        null,
        this.availableLanguages['nl'] ? [Validators.required] : []
      ],
      title_de: [
        null,
        this.availableLanguages['de'] ? [Validators.required] : []
      ],
      title_fr: [
        null,
        this.availableLanguages['fr'] ? [Validators.required] : []
      ],
      title_es: [
        null,
        this.availableLanguages['es'] ? [Validators.required] : []
      ]
    })
  }

  public addConfigSetRow(): void {
    this.configSetsFormArray.push(this.getConfigSetRow())
  }

  public deleteConfigSetRow(index): void {
    this.configSetsFormArray.removeAt(index)
  }

  public onFormSubmit(): void {
    // prevent saving if form hasnt been modified to avoid data loss
    if (this.form.pristine) {
      console.warn('Form is pristine, skipping save to prevent data loss')
      return
    }

    if (this.form.invalid) {
      this.markGroupDirty(this.form)
      return
    }

    this.onSubmit.emit({
      secondary_tag_filter_config: JSON.stringify(this.form.value.configSets)
    })
  }

  markGroupDirty(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      switch (formGroup.get(key).constructor.name) {
        case 'FormGroup':
          this.markGroupDirty(formGroup.get(key) as UntypedFormGroup)
          break
        case 'FormArray':
          this.markArrayDirty(formGroup.get(key) as UntypedFormArray)
          break
        case 'FormControl':
          this.markControlDirty(formGroup.get(key) as UntypedFormControl)
          break
      }
    })
  }
  markArrayDirty(formArray: UntypedFormArray) {
    formArray.controls.forEach((control) => {
      switch (control.constructor.name) {
        case 'FormGroup':
          this.markGroupDirty(control as UntypedFormGroup)
          break
        case 'FormArray':
          this.markArrayDirty(control as UntypedFormArray)
          break
        case 'FormControl':
          this.markControlDirty(control as UntypedFormControl)
          break
      }
    })
  }
  markControlDirty(formControl: UntypedFormControl) {
    formControl.markAsDirty()
  }
}
